import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {CommonController} from "../Controllers/CommonController"

const ActivityTracker = () => {
  const location = useLocation();
  const lastTrackedPath = useRef<string>("");

 const getPageNameFromPath = (path: string): string => {
  if (!path || path === "/") return "Home";

  const parts = path
    .replace(/^\/+|\/+$/g, "")
    .split("/")
    .filter(part => !/^\d+$/.test(part)); // remove numeric ids if any

  // take only the last part
  const lastPart = parts[parts.length - 1] || "Home";

  return lastPart
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, c => c.toUpperCase());
};

  useEffect(() => {
    const userId = sessionStorage.getItem("uid");
    const userType = sessionStorage.getItem("user_type_id");

    // if user not logged in, do not track
    if (!userId) return;

    const currentPath = location.pathname;
    // prevent duplicate tracking for same path
    if (lastTrackedPath.current === currentPath) return;
    lastTrackedPath.current = currentPath;

    const pageVisited = getPageNameFromPath(currentPath);
  
const baseUrl = window.location.origin;
    var data = {
            "User_ID":userId,
            "SCRIPT_NAME":pageVisited,
            "URL_USED":baseUrl
        };

let commonController = new CommonController();

commonController.UpdateActivity(data)
  .then(response => {
  })
  .catch(error => {
    console.error("There was an error:", error);
  });



   
  }, [location.pathname]);

  return null;
};

export default ActivityTracker;